/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "surface_scan";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface UserControls {
  disableZoomSlider: boolean;
  disableUserZoomInput: boolean;
  disableTapToFocus: boolean;
  disableCameraSettings: boolean;
  disableManualFocus: boolean;
}

function createBaseUserControls(): UserControls {
  return {
    disableZoomSlider: false,
    disableUserZoomInput: false,
    disableTapToFocus: false,
    disableCameraSettings: false,
    disableManualFocus: false,
  };
}

export const UserControls = {
  encode(message: UserControls, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.disableZoomSlider === true) {
      writer.uint32(8).bool(message.disableZoomSlider);
    }
    if (message.disableUserZoomInput === true) {
      writer.uint32(16).bool(message.disableUserZoomInput);
    }
    if (message.disableTapToFocus === true) {
      writer.uint32(24).bool(message.disableTapToFocus);
    }
    if (message.disableCameraSettings === true) {
      writer.uint32(32).bool(message.disableCameraSettings);
    }
    if (message.disableManualFocus === true) {
      writer.uint32(40).bool(message.disableManualFocus);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UserControls {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserControls();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.disableZoomSlider = reader.bool();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.disableUserZoomInput = reader.bool();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.disableTapToFocus = reader.bool();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.disableCameraSettings = reader.bool();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.disableManualFocus = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserControls {
    return {
      disableZoomSlider: isSet(object.disableZoomSlider) ? globalThis.Boolean(object.disableZoomSlider) : false,
      disableUserZoomInput: isSet(object.disableUserZoomInput)
        ? globalThis.Boolean(object.disableUserZoomInput)
        : false,
      disableTapToFocus: isSet(object.disableTapToFocus) ? globalThis.Boolean(object.disableTapToFocus) : false,
      disableCameraSettings: isSet(object.disableCameraSettings)
        ? globalThis.Boolean(object.disableCameraSettings)
        : false,
      disableManualFocus: isSet(object.disableManualFocus) ? globalThis.Boolean(object.disableManualFocus) : false,
    };
  },

  toJSON(message: UserControls): unknown {
    const obj: any = {};
    if (message.disableZoomSlider === true) {
      obj.disableZoomSlider = message.disableZoomSlider;
    }
    if (message.disableUserZoomInput === true) {
      obj.disableUserZoomInput = message.disableUserZoomInput;
    }
    if (message.disableTapToFocus === true) {
      obj.disableTapToFocus = message.disableTapToFocus;
    }
    if (message.disableCameraSettings === true) {
      obj.disableCameraSettings = message.disableCameraSettings;
    }
    if (message.disableManualFocus === true) {
      obj.disableManualFocus = message.disableManualFocus;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserControls>, I>>(base?: I): UserControls {
    return UserControls.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserControls>, I>>(object: I): UserControls {
    const message = createBaseUserControls();
    message.disableZoomSlider = object.disableZoomSlider ?? false;
    message.disableUserZoomInput = object.disableUserZoomInput ?? false;
    message.disableTapToFocus = object.disableTapToFocus ?? false;
    message.disableCameraSettings = object.disableCameraSettings ?? false;
    message.disableManualFocus = object.disableManualFocus ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
